module.exports = __webpack_public_path__ + "static/media/icon_close_2.d1d1e1f2.svg";